export const WORD_EXIST = 'WORD_EXIST';
export const WORD_CREATED_SUCCESSFULLY = 'WORD_CREATED_SUCCESSFULLY';
export const FILES_URL =
  'https://raw.githubusercontent.com/irinainina/rslang-data/master/';
export const BACKEND_URL = 'https://afternoon-falls-25894.herokuapp.com';
// export const BACKEND_URL = 'https://pacific-castle-12388.herokuapp.com';
